import { observer } from 'mobx-react';
import React from 'react';
import 'reactflow/dist/style.css';
import {
	DefaultButton,
	MessageBar,
	MessageBarType,
	Spinner,
	SpinnerSize,
	Stack,
	StackItem,
} from '@fluentui/react';
import LegalEntityDocument from './LegalEntityDocument';
import OutlookFileDocumentsDlg from './OutlookFileDocumentsDlg';
import OutlookLocationContentsViewerState from '../state/CorporateArchiveStates/LegalEntityDocumentsStateOutlook';
import LocationLineItemCtrl from './LocationLineItemCtrl';
import TemplateDocumentsList from '../components/controls/TemplateDocumentsList';
import DragDropTarget from './DragDropTarget';

interface ILegalEntityDocumentsProps {
	state: OutlookLocationContentsViewerState;
	indent: number;
}

class LegalEntityFolder extends React.Component<
	ILegalEntityDocumentsProps,
	{}
> {
	componentDidMount(): void {
		this.props.state.ensureInitialLoaded();
	}

	render() {
		if (this.props.state.loading) return <Spinner size={SpinnerSize.large} />;

		return (
			<>
				<Stack style={{ marginLeft: this.props.indent === 0 ? 0 : 16 }}>
					{this.props.state.error && (
						<MessageBar messageBarType={MessageBarType.error}>
							{this.props.state.error}
						</MessageBar>
					)}

					{this.getStorageInfoMessage()}


					{this.props.state.folderStates.map((d) => (
						<StackItem>
							{LegalEntityFolder.getFolderComponents(this.props.indent + 1, d)}
						</StackItem>
					))}

					{this.props.state.documentStates.map((d) => (
						<StackItem>
							<LegalEntityDocument key={d.document.webUrl} state={d} />
						</StackItem>
					))}
				</Stack>
			</>
		);
	}

	private getStorageInfoMessage(): React.ReactNode {
		
		if(!this.props.state.url || this.props.state.url.startsWith('lia://')) {
			//Add a refresh button to the messagebar
			return <MessageBar>Workspace is not yet available. File items and they'll be moved to it when it's ready. <DefaultButton sizes='small' text="Refresh" onClick={() => this.props.state.load()} /></MessageBar>;
		}

		if (this.props.state.documentStates.length === 0 &&
			this.props.state.folderStates.length === 0 &&
			!this.props.state.error) {
			return <MessageBar>There are no contents to display.</MessageBar>;
		}

		return <></>;
	}

	public static getFolderComponents(indent: number, state: OutlookLocationContentsViewerState) {

		return <>
			<OutlookFileDocumentsDlg state={state.outlookFiling} />
			<TemplateDocumentsList state={state.templates} />
			{this.getLineItem(indent, state)}
		</>;


	}

	private static getLineItem(indent: number, state: OutlookLocationContentsViewerState) {

		let innards = <>
			<LocationLineItemCtrl state={state.lineItem} />
			{/* Render the children, if this folder is expanded */}
			{state.lineItem.isExpanded && (
				<LegalEntityFolder indent={indent} state={state} />
			)}
		</>;

		if (state.isFileable) {
			return <DragDropTarget state={state.dnd}>
				{innards}
			</DragDropTarget>
		} else {
			return innards;
		}
	}
}

export default observer(LegalEntityFolder);
